import { sx } from '@lucifer/sx';
import Section from '~/components/Section';

export const SectionPassword = sx(Section)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});
